import { render, staticRenderFns } from "./Lgx264047748465033216.vue?vue&type=template&id=3143f3aa&scoped=true&"
import script from "./Lgx264047748465033216.vue?vue&type=script&lang=js&"
export * from "./Lgx264047748465033216.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143f3aa",
  null
  
)

export default component.exports